module.exports = __webpack_public_path__ + "logo-SWO.png?39812ea6bb1032f3f29dcdef0989b0ef";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/logo-SWO.png
// module id = 79
// module chunks = 0